export const isBrowser = typeof window !== "undefined";

export const getViewportIsMobile = () => {
  if (!isBrowser) {
    return false;
  }

  return window.innerWidth <= 768;
};

export const getStorageItem = (key, fallback = null) => {
  if (!isBrowser) {
    return fallback;
  }

  try {
    const value = localStorage.getItem(key);
    return value === null ? fallback : value;
  } catch {
    return fallback;
  }
};

export const getJsonStorageItem = (key, fallback = null) => {
  const value = getStorageItem(key, null);

  if (!value) {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const setStorageItem = (key, value) => {
  if (!isBrowser) {
    return;
  }

  try {
    localStorage.setItem(key, value);
  } catch {}
};

export const removeStorageItem = (key) => {
  if (!isBrowser) {
    return;
  }

  try {
    localStorage.removeItem(key);
  } catch {}
};

export const clearStorage = () => {
  if (!isBrowser) {
    return;
  }

  try {
    localStorage.clear();
  } catch {}
};
